import axios from 'axios';

export const fetchServiceFactory = async (idToken, carNo) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/booking/service_factory/${carNo}`,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
    }
  );
  return response.data;
};

export const fetchBpServiceFactory = async (idToken) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/booking/bp_service_factory`,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
    }
  );
  return response.data;
};

export const fetchTwinFactory = async (idToken, carNo, dlrCode, brnhCode) => {
  const queryString = new URLSearchParams({
    dlr_code: dlrCode,
    brnh_code: brnhCode,
  }).toString();

  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/booking/sub_service_factory/${carNo}?${queryString}`,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
    }
  );
  return response.data;
};

export const fetchAvailableTime = async (idToken, dlrCode, brnhCode) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/booking/available_time/${dlrCode}/${brnhCode}`,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
    }
  );
  return response.data;
};

export const fetchAvailableTimeV2 = async (
  idToken,
  carNo,
  dlrCode,
  brnhCode,
  rmFlag,
  fixFlag
) => {
  const queryString = new URLSearchParams({
    dlr_code: dlrCode,
    brnh_code: brnhCode,
    rm_flag: rmFlag,
    fix_flag: fixFlag,
  }).toString();

  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/booking/available_time_v2/${carNo}?${queryString}`,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
    }
  );
  return response.data;
};

export const fetchBpAvailableTime = async (
  idToken,
  carNo,
  dlrCode,
  brnhCode
) => {
  const queryString = new URLSearchParams({
    dlr_code: dlrCode,
    brnh_code: brnhCode,
  }).toString();

  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/booking/bp_available_time/${carNo}?${queryString}`,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
    }
  );
  return response.data;
};

export const submitBooking = async (
  idToken,
  carNo,
  formData,
  selectedCenter,
  lastBooking
) => {
  const payload = {
    car_no: carNo,
    dlr_code: selectedCenter.dlr_code,
    brnh_code: selectedCenter.brnh_code,
    brnh_name: selectedCenter.name,
    brnh_tel: selectedCenter.tel,
    date: formData.date,
    time: formData.time,
    contact_name: formData.name,
    contact_phone: formData.phone,
    contact_time: formData.contactTime,
    notify_type: formData.notify,
    remark: formData.comment,
    gv: formData.wait === 'yes' ? true : false,
  };

  let response;
  if (lastBooking) {
    response = await axios.put(
      `${process.env.REACT_APP_BASE_URL}/booking/${carNo}`,
      { ...payload, s_key: lastBooking.s_key },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
          'ngrok-skip-browser-warning': 'true',
        },
      }
    );
  } else {
    response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/booking/`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
          'ngrok-skip-browser-warning': 'true',
        },
      }
    );
  }
  return response.data;
};

export const submitMaintenanceBooking = async (
  idToken,
  carNo,
  formData,
  selectedCenter,
  serviceItems,
  otherRepairs,
  customText
) => {
  const hasFixFlag =
    Object.entries(otherRepairs).some(
      ([key, checked]) => checked && key !== '自行輸入'
    ) ||
    (otherRepairs['自行輸入'] && customText);

  const payload = {
    car_no: carNo,
    dlr_code: selectedCenter.dlr_code,
    brnh_code: selectedCenter.brnh_code,
    date: formData.date,
    time: formData.time,
    contact_name: formData.name,
    contact_phone: formData.phone,
    remark: formData.comment,
    gv: formData.wait === 'yes',
    rm_flag: serviceItems['定期保養'] ? 'Y' : 'N',
    fix_flag: hasFixFlag ? 'Y' : 'N',
    opno_type: '',
  };

  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/booking/maintenance_booking`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
    }
  );
  return response.data;
};

export const fetchPastBooking = async (idToken, carNo, sKey) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/booking/${carNo}?s_key=${sKey}`,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
    }
  );
  return response.data;
};

export const fetchBookingCalendar = async (idToken, token) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/booking/calendar`,
    {
      token,
    },
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
      responseType: 'blob',
    }
  );
  return response.data;
};

export const fetchMaintainanceAdvice = async (idToken, carNo) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/booking/maintainance_advice/${carNo}`,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
    }
  );
  return response.data;
};

export const fetchBookingAvailable = async (idToken, carNo) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/booking/get_booking_available/${carNo}`,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
    }
  );
  return response.data;
};

export const fetchBookedDetail = async (
  idToken,
  carNo,
  dlrCode,
  brnhCode,
  sKey,
  workNo
) => {
  const queryString = new URLSearchParams({
    dlr_code: dlrCode,
    brnh_code: brnhCode,
    s_key: sKey,
    work_no: workNo,
  }).toString();

  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/booking/booked_detail/${carNo}?${queryString}`,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
    }
  );
  return response.data;
};

export const submitBpBooking = async (idToken, carNo, payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/booking/bp/${carNo}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
    }
  );
  return response.data;
};

export const uploadBpDamagePhotos = async (
  idToken,
  dlrCode,
  brnhCode,
  bpEvaNo,
  images
) => {
  const formData = new FormData();
  formData.append('dlr_code', dlrCode);
  formData.append('brnh_code', brnhCode);
  formData.append('bp_eva_no', bpEvaNo);
  images.forEach((file, idx) => {
    formData.append(`file${idx + 1}`, file, file.name || `photo${idx + 1}.jpg`);
  });

  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/booking/bp_upload_photos`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

export const fetchInsuranceClaimUrl = async (
  idToken,
  dlrCode,
  brnhCode,
  bpEvaNo
) => {
  const queryString = new URLSearchParams({
    dlr_code: dlrCode,
    brnh_code: brnhCode,
    bp_eva_no: bpEvaNo,
  }).toString();

  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/booking/insurance_claim_url?${queryString}`,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
    }
  );
  return response.data;
};

export const modifyBooking = async (idToken, carNo, payload) => {
  const response = await axios.put(
    `${process.env.REACT_APP_BASE_URL}/booking/modify/${carNo}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
    }
  );
  return response.data;
};

export const fetchBpBookedDetail = async (
  idToken,
  carNo,
  dlrCode,
  brnhCode,
  bpEvaNo
) => {
  const queryString = new URLSearchParams({
    dlr_code: dlrCode,
    brnh_code: brnhCode,
    bp_eva_no: bpEvaNo,
  }).toString();

  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/booking/bp_booked_detail/${carNo}?${queryString}`,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
    }
  );
  return response.data;
};

export const cancelBooking = async (
  idToken,
  carNo,
  sKey,
  dlrCode,
  brnhCode,
  workNo
) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_URL}/booking/${carNo}`,
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'ngrok-skip-browser-warning': 'true',
      },
      data: {
        s_key: sKey,
        dlr_code: dlrCode,
        brnh_code: brnhCode,
        work_no: workNo,
      },
    }
  );
  return response.data;
};

export class StringFormatter {
  static toFullWidthDigits(str) {
    return str.replace(/[0-9]/g, (digit) =>
      String.fromCharCode(digit.charCodeAt(0) + 0xfee0)
    );
  }

  static toHalfWidthDigits(str) {
    return str.replace(/[０-９]/g, (digit) =>
      String.fromCharCode(digit.charCodeAt(0) - 0xfee0)
    );
  }
}
